import { excludeKeys } from '@repo/common-utils';
import { PageViewEventLogger } from '@repo/tracking-service';
import Head from 'next/head';
import { JSX, useEffect } from 'react';

import { BOOSTING_LAB_TYPE, SectionScrollModelProvider, useSectionScrollModel } from '@/components/common/context/SectionScrollModelProvider';
import { CountDownCTA } from '@/components/landing/CountDownCTA';
import EventModal from '@/components/landing/EventModal';
import HelpGuide from '@/components/landing/HelpGuide';
import { LandingContent } from '@/components/landing/LandingContent';
import { LandingCtaButton } from '@/components/landing/LandingCtaButton';
import { ModelContent } from '@/components/landing/ModelContent';
import RefundFAQ from '@/components/landing/RefundFAQ';
import HomeLayout from '@/components/layout/HomeLayout';
import { useAffiliateQueryParams } from '@/lib/hooks/use-affiliate';
import { useInviteEventSessionData, useProceedingEvent } from '@/lib/web/use-event';

const Landing = () => {
  const inviteData = useInviteEventSessionData();
  const currentEvent = useProceedingEvent();
  const { labId, labType, eventAttribute } = useSectionScrollModel();
  const isExperimentContent = labType && labId === 'experiment';
  useAffiliateQueryParams();

  useEffect(() => {
    inviteData.set();
  }, [inviteData]);

  return (
    <>
      <HomeLayout>
        {isExperimentContent ? <ModelContent /> : <LandingContent />}
        <RefundFAQ sectionId={'07'} maxWidth={'700'} />
        <HelpGuide sectionId={'08'} maxWidth={'700'} />

        {currentEvent && <EventModal event={currentEvent} />}
      </HomeLayout>
      {labType === BOOSTING_LAB_TYPE && labId === 'experiment' ? (
        <CountDownCTA
          endDate="2026-01-31T23:59:59+09:00"
          title={
            <p className={'flex items-center gap-tiny-small body-small-bold text-yellow-400 leading-[145%]'}>
              <img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/care/svg/icg_bell_sm.svg`} alt="Bell icon" width={24} height={24} />
              <span>2026년 1월 환급 접수 종료</span>
            </p>
          }
          backgroundClassName="bg-[linear-gradient(180deg,#4562F4_0%,#E3E2FF_100%)]"
          buttonClassName="!bg-[#5A2EEA]"
        />
      ) : (
        <LandingCtaButton />
      )}
      <PageViewEventLogger
        pageName={'landing'}
        eventProperty={excludeKeys(eventAttribute ?? {}, ['current_section'])}
        eventOption={{ isUseAirbridge: true, isUseGoogleAnalytics: true }}
      />
    </>
  );
};

Landing.getLayout = (page: JSX.Element) => (
  <>
    <Head>
      <title>종합소득세 환급금 무료 조회 | 비즈넵 환급</title>
    </Head>
    <SectionScrollModelProvider>{page}</SectionScrollModelProvider>
  </>
);

export default Landing;
